import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  addFilterButton: {
    fontWeight: 900,
    padding: '45px !important',
    selectors: {
      '&:focus': {
        outline: 'thin !important',
      },
    },
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
});
